import React from 'react';
import './Toast.css';

// Shared Direction B "Stream" toast — a centered dark pill that floats near the
// bottom of the screen and auto-dismisses. Controlled: the parent renders it
// with a truthy `message` and clears the message on its own timer. Reused
// across the chat thread (capture confirmations), the Today stream, and the
// ask sheet so every transient confirmation looks and sits the same.
function Toast({ message, bottom = 90 }) {
  if (!message) return null;
  return (
    <div
      className="app-toast"
      role="status"
      aria-live="polite"
      style={bottom !== 90 ? { bottom } : undefined}
    >
      {message}
    </div>
  );
}

export default Toast;
